import { createAction, props } from '@ngrx/store';
import {
  TrustedDestination,
  TrustedDestinationListMeta,
  TrustedDestinationPayload,
} from '../models/trusted-destination.model';
import { ApiTableFilter } from '../../../shared/models/table-filter.model';

// Load list
export const loadTrustedDestinations = createAction(
  '[Trusted Destinations] Load Trusted Destinations',
  props<{
    page?: number;
    perPage?: number;
    search?: string;
    sort?: string;
    sortDirection?: string;
    filters?: ApiTableFilter[];
    filterLink?: string;
  }>()
);

export const loadTrustedDestinationsSuccess = createAction(
  '[Trusted Destinations] Load Trusted Destinations Success',
  props<{ items: TrustedDestination[]; meta: TrustedDestinationListMeta }>()
);

export const loadTrustedDestinationsFailure = createAction(
  '[Trusted Destinations] Load Trusted Destinations Failure',
  props<{ error: string }>()
);

// Load single item
export const loadTrustedDestination = createAction(
  '[Trusted Destinations] Load Trusted Destination',
  props<{ uuid: string }>()
);

export const loadTrustedDestinationSuccess = createAction(
  '[Trusted Destinations] Load Trusted Destination Success',
  props<{ item: TrustedDestination }>()
);

export const loadTrustedDestinationFailure = createAction(
  '[Trusted Destinations] Load Trusted Destination Failure',
  props<{ error: string }>()
);

// Create
export const createTrustedDestination = createAction(
  '[Trusted Destinations] Create Trusted Destination',
  props<{ payload: TrustedDestinationPayload }>()
);

export const createTrustedDestinationSuccess = createAction(
  '[Trusted Destinations] Create Trusted Destination Success'
);

export const createTrustedDestinationFailure = createAction(
  '[Trusted Destinations] Create Trusted Destination Failure',
  props<{ error: string }>()
);

// Update
export const updateTrustedDestination = createAction(
  '[Trusted Destinations] Update Trusted Destination',
  props<{ uuid: string; payload: TrustedDestinationPayload }>()
);

export const updateTrustedDestinationSuccess = createAction(
  '[Trusted Destinations] Update Trusted Destination Success'
);

export const updateTrustedDestinationFailure = createAction(
  '[Trusted Destinations] Update Trusted Destination Failure',
  props<{ error: string }>()
);

// Delete
export const deleteTrustedDestination = createAction(
  '[Trusted Destinations] Delete Trusted Destination',
  props<{ uuid: string }>()
);

export const deleteTrustedDestinationSuccess = createAction(
  '[Trusted Destinations] Delete Trusted Destination Success'
);

export const deleteTrustedDestinationFailure = createAction(
  '[Trusted Destinations] Delete Trusted Destination Failure',
  props<{ error: string }>()
);

// Export
export const exportTrustedDestinations = createAction(
  '[Trusted Destinations] Export Trusted Destinations',
  props<{
    selectedRows: string[];
    filters?: ApiTableFilter[];
    filterLink?: string;
    search?: string;
    sort?: string;
    sortDirection?: string;
  }>()
);

export const exportTrustedDestinationsSuccess = createAction(
  '[Trusted Destinations] Export Trusted Destinations Success'
);

export const exportTrustedDestinationsFailure = createAction(
  '[Trusted Destinations] Export Trusted Destinations Failure',
  props<{ error: string }>()
);

// Selection
export const selectTrustedDestination = createAction(
  '[Trusted Destinations] Select Trusted Destination',
  props<{ item: TrustedDestination | null }>()
);

export const clearSelection = createAction(
  '[Trusted Destinations] Clear Selection'
);

// Reset state
export const resetTrustedDestinationsState = createAction(
  '[Trusted Destinations] Reset State'
);
